import _ from '../../../../../utils/lodash-optimized'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import PD from '../../../../../lib/IssueMapping/PatientDemographics'
import { notify } from '../../../../../lib/Notification/actions'
import * as Mapper from '../../../../../lib/Proxy/patient'
import { mapPatientToForm } from '../../../../../lib/Proxy/patient'
import { useAppSelector } from '../../../../../store'
import { IGAO } from '../../../../igao'
import * as Card from '../../../../shared/card'
import IssueQueuer from '../../../../shared/IssueQueuer'
import { CircularProgress } from '../../../../shared/NarusMaterial'
import { updatePatient } from '../../../../shared/PatientForm/actions'
import PatientForm from '../../../../shared/PatientForm/form'

export function PatientDemographics (): JSX.Element {
  let dispatch = useDispatch()
  let eoc = useSelector<{patient: {compartment: {EpisodeOfCare: Record<string, { status: string }>}}}, Record<string, { status: string }>>((state) => state?.patient?.compartment?.EpisodeOfCare)
  let patientId = useAppSelector<unknown | undefined>((state) => state.globalVars?.params?.id)
  let practitionerId = useAppSelector<unknown | undefined>((state) => state.auth?.profile?.sub)
  let encounterId = useAppSelector((state) => state.encounter?.encounter?.id)
  let patient = useSelector<{patient: {compartment: {Patient: Record<string, unknown>}}}, unknown | undefined>((state) => Object.values(state.patient.compartment.Patient)?.[0])

  let [ counter, setCounter ] = useState(0)
  let [ initialValues, setInitialValues ] = useState(patient ? mapPatientToForm(patient) : {})

  if (!eoc || !patientId || !practitionerId || !encounterId || !patient) {
    return (
      <CircularProgress />
    )
  }

  function handleSubmit (data: { emails: string[] }): void {
    let tempData = { ...data }
    queueIssues(tempData)
    tempData.emails = _.compact(data?.emails)
    let patientToSave = Mapper.mapFormToPatient(data)
    // @ts-expect-error //it's okay
    dispatch(updatePatient(patientToSave))
  }

  function queueIssues (data: object): void {
    let iq = new IssueQueuer({
      dispatch,
      patientId,
      practitionerId,
      encounterId
    })

    if (Object.values(eoc)?.[0]?.status === 'active') {
      iq.queueIssues({
        mapping: PD,
        currentForm: data,
        existingForms: undefined
      })
    } else {
      // @ts-expect-error //it's okay
      dispatch(notify(
        'Patient demographic IGAOs can only be created when case is active.',
        true
      ))
    }
  }

  return (
    <div
      className='main'
      style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}
    >
      <Card.Card expandable>
        <Card.Header>
          <h2>Patient Demographics</h2>
        </Card.Header>
        <Card.ExpandableWrapper>
          {/* @ts-expect-error - Redux connect type incompatibility with TypeScript 5.9 */}
          <PatientForm
            // @ts-expect-error - Redux connect type incompatibility
            key={`patient-form-${counter.toString(10)}`}
            // @ts-expect-error // it's okay
            formKey='patientForm'
            // @ts-expect-error // it's okay
            onSubmit={handleSubmit}
            // @ts-expect-error // it's okay
            value={initialValues}
            // @ts-expect-error // it's okay
            cancel={() => {
              setInitialValues(mapPatientToForm(patient))
              setCounter(counter + 1)
            }}
          />
        </Card.ExpandableWrapper>
      </Card.Card>
      <IGAO path='patient' />
    </div>
  )
}
